import React from 'react'

import drawerStyles from '../../../editor/styles/components/Drawer.module.scss'
import styles from './detailDrawer.module.scss'

type DetailDrawerProps = {
  className: string
  children: React.ReactNode
}

const DetailDrawer: React.FC<DetailDrawerProps> = props => {
  const { className, children } = props
  return (
    <section className="openDrawer">
      <div
        className={`${styles.detailDrawer} ${
          drawerStyles.imageDrawer
        } ${className && className}`}
      >
        {children}
      </div>
    </section>
  )
}

export default DetailDrawer
